import { render, staticRenderFns } from "./detailpayment.vue?vue&type=template&id=0a4937f6&scoped=true&"
import script from "./detailpayment.vue?vue&type=script&lang=js&"
export * from "./detailpayment.vue?vue&type=script&lang=js&"
import style0 from "./detailpayment.vue?vue&type=style&index=0&id=0a4937f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4937f6",
  null
  
)

export default component.exports